import { Theme, Tooltip } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import React from "react";
import { ReactAdminComponentProps, useTranslate } from "react-admin";
import resourceNames from "../../../common/data/resourceNames";
import dataGridFields from "../../common/data-grid-fields";
import ReportIcon from "@material-ui/icons/Report";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import permissionNames from "../../../common/auth/access-control/permissionNames";

interface Props extends ReactAdminComponentProps {
  record?: {
    [key: string]: any;
  } & object;
}

export const DriverWithViolationsField = ({ record, history }: Props) => {
  const theme: Theme = useTheme();
  const translate = useTranslate();
  const permissions = useActionPermissions();
  return (
    <dataGridFields.ColoredField
      record={record}
      onClick={() =>
        permissions[permissionNames.hos.violations.view]
          ? history?.push(
              `/${resourceNames.HOS_DRIVER_VIOLATIONS}/${record?.id}`
            )
          : {}
      }
      className="violations-field centered-content"
      color={() => theme.palette.error.main}
      backgroundColor={() => "auto"}
      source="violations">
      <Tooltip
        title={translate("resources.drivers.labels.driverHadViolations")}>
        <ReportIcon />
      </Tooltip>
    </dataGridFields.ColoredField>
  );
};
